export default __webpack_public_path__ + "static/media/good-conversion.015601a3.svg";